import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { first } from 'rxjs'

import { DatePipe, NgIf } from '@angular/common'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import {
  DialogService,
  KENDO_DIALOGS,
  WindowCloseResult,
  WindowRef,
  WindowService,
} from '@progress/kendo-angular-dialog'
import { KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, GridComponent, KENDO_GRID } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import { TasksAndMarketingService } from '../../@theme/services/tasksAndMarketing.service'
import { MiddlemanService } from '../../auth/services/Middleman.service'
import { FilemanagerComponent } from '../FileManager/filemanager.component'
import { MarketingDetailsComponent } from './marketing-details/marketing-details.component'
import { MarketingEditorComponent } from './marketing-editor/marketing-editor.component'

@Component({
  selector: 'gd-marketing',
  templateUrl: './marketing.component.html',
  styleUrls: ['./marketing.component.scss'],
  imports: [
    NgIf,
    GridComponent,
    DataBindingDirective,
    ColumnComponent,
    CellTemplateDirective,
    CommandColumnComponent,
    KENDO_DIALOGS,
    KENDO_BUTTONS,
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_INDICATORS,
    DatePipe,
  ]
})
export class MarketingComponent implements OnInit {
  public marketingItems: any[]
  public viewallblot: string
  public selectedMarketingId: number
  public view: boolean
  public windowRef: WindowRef = null
  constructor(
    private marketingService: TasksAndMarketingService,
    private dialogService: DialogService,
    private middlemanService: MiddlemanService,
    private router: Router,
    private windowService: WindowService,
  ) {
    this.viewallblot = ''
    this.view = true
  }

  ngOnInit() {
    /*  this.marketingService
      .getMarketingView({ orderBy: '' })
      .subscribe((response) => {
        this.marketingItems = response
      }) */
    this.marketingService
      .getMarketingView()
      .pipe(first())
      .subscribe((response) => {
        this.marketingItems = response
        this.view = true
      })
  }

  viewMarketingItem(marketingId: number) {
    const clientInfoDialogRef = this.dialogService.open({
          title: 'View Client',
          content: MarketingDetailsComponent,
          maxHeight: '95%',
          width: '850px',
          maxWidth: '95%',
          actions: [{ text: 'Close', themeColor: 'primary' }],
        })
    
        const clientInfo = clientInfoDialogRef.content.instance
        clientInfo.clientId = marketingId
  }

  editMarketingItem(marketingId: number) {
    const clientInfoDialogRef = this.dialogService.open({
          title: 'View Client',
          content: MarketingEditorComponent,
          maxHeight: '95%',
          width: '850px',
          maxWidth: '95%',
          actions: [{ text: 'Close', themeColor: 'primary' }],
        })
    
        const clientInfo = clientInfoDialogRef.content.instance
        clientInfo.clientId = marketingId
    // this.middlemanService.updateMarketingIdSubject(marketingId);
    // this.router.navigate(['/pages/marketing/edit']);
  }

  viewFilesForMarketingItem(marketingId: number) {
    // If windowRef is not null, close the window before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }

    this.selectedMarketingId = marketingId

    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })

    const fileManager = this.windowRef.content.instance

    fileManager.viewallblot = this.viewallblot
    fileManager.marketingId = this.selectedMarketingId.toString()

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }

  fileManagerClose() {
    this.selectedMarketingId = null
  }
}
